export const EmptyStateEvents = {
  LINK_CLICK: 'emptyStateLinkClick',
  BUTTON_CLICK: 'emptyStateButtonClick'
};
export default EmptyStateEvents;